import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi } from "../../ApiNames";

type Nullable<T> = T | null;

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data
})
export const fetchDataViewSuccess = (viewdata: any) => ({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: viewdata,
});
export const ApproveDataSuccess = (applydata: any) => ({
    type: 'APPLY_DATA_SUCCESS',
    payload: applydata,
});
export const RejectDataSuccess = (rejectdata: any) => ({
    type: 'Reject_DATA_SUCCESS',
    payload: rejectdata,
});
export const fetchdocdata = (docdata: any) => ({
    type: 'VIEW_DATA_SUCCESS',
    payload: docdata,
});
export const fetchdata = (uid:any,fundman_id:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid,fid:fundman_id,q:3};
            const apiname = orgapi.orgapplication
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}
export const fetchviewdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid,q:1};
            const apiname = orgapi.orgapplication
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataViewSuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}
export const ApplyData = ( uid:any,fundman_id:any,description:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 2,userid:uid,needs:fundman_id,description:description};
            const apiname = orgapi.orgapplication;
            const response = await LoginService.getData(apiname,payload)
            dispatch(ApproveDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const RejectData = ( fundman_id:string) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 5,need:fundman_id};
            const apiname = orgapi.orgapplication;
            const response = await LoginService.getData(apiname,payload)
            dispatch(RejectDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchviewDoc = ( uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = orgapi.orgdocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdocdata(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};